import { NCRService } from "../_services/ncr.service";

export const NCRServiceAction = {
  headsList,
  subHeadList,
  addNCR,
  getNCRByMaster,
  NcrCount,
  NcrList,
};
function headsList() {
  return NCRService.headsList();
}
function subHeadList(values) {
  return NCRService.subHeadList(values);
}
function addNCR(value) {
  return NCRService.addNCR(value);
}
function getNCRByMaster(values) {
  return NCRService.getNCRByMaster(values);
}
function NcrCount(values) {
  return NCRService.NcrCount(values);
}
function NcrList(values) {
  return NCRService.NcrList(values);
}
